import React from 'react'

import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'

export type ActionButtonProps = React.ComponentProps<typeof Button> & {
  isProcessing: boolean
  isProcessingText?: React.ReactNode
  showIsProcessingText?: boolean
  showSpinner?: boolean
}

const ActionButton: React.FC<ActionButtonProps> = ({
  children,
  isProcessing,
  isProcessingText = 'Processing',
  disabled = isProcessing,
  showIsProcessingText = true,
  showSpinner = true,
  ...props
}) => {
  return (
    <Button disabled={disabled} {...props}>
      {isProcessing && showIsProcessingText ? isProcessingText : children}
      {isProcessing && showSpinner && <Spinner />}
    </Button>
  )
}

export default ActionButton
